export default "__VITE_ASSET__CLcWLTZ$__"